import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HealthInsuranceService {

  constructor(private http: HttpClient) {}

  getHealthInsuranceData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/health-insurances`);
  }

  updateHealthInsuranceData(formsId: number, healthInsuranceId: number, data: any): Observable<any> {
    return this.http.patch(`${environment.api_guia}forms/${formsId}/health-insurances/${healthInsuranceId}`, data);
  }
}
